import React from "react";
import { Tag } from "primereact/tag";
import styles from "../entity-calendar.module.scss";
import ReactCountryFlag from "react-country-flag";
import PropTypes from "prop-types";
import EventDetail from "./EventDetail";

const EventDetailCalander = ({
  eventDetail,
  formatDate,
  handleCloseEventDetailCalander,
  backBtn,
  handleViewMoreEvent,
  entity,
}) => {
  return (
    <div className={styles["event-detail-container"]}>
      <div className={styles["event-header-container"]}>
        {backBtn && (
          <span className={styles["back"]}>
            <i className="pi pi-arrow-left" onClick={handleViewMoreEvent}></i>
          </span>
        )}

        <div className={styles["event-header"]}>
          <h2 className={styles["event-header-title"]}>
            {eventDetail?.title} {eventDetail?.statusData?.primary_color}
            <Tag
              value={
                eventDetail?.type === "EVENT" ? eventDetail?.label : "Holiday"
              }
              style={
                eventDetail?.type === "EVENT" && {
                  backgroundColor: eventDetail?.color,
                }
              }
              className={styles["event-tag"]}
            />
          </h2>
        </div>
        <span className={styles["close__calander"]}>
          <i
            className="pi pi-times"
            onClick={handleCloseEventDetailCalander}
          ></i>
        </span>
      </div>
      {eventDetail?.type === "EVENT" ? (
        <EventDetail eventDetail={eventDetail} entity={entity} />
      ) : (
        <>
          <p className={styles["event-description"]}>{eventDetail?.oneliner}</p>

          <div className={styles["p-field"]}>
            <label>Country</label>
            <p className={styles["event-input"]}>
              <ReactCountryFlag
                countryCode={eventDetail.country}
                svg
                className={styles["country_flag"]}
              />
              {eventDetail.subTitle}
            </p>
          </div>

          <div className={styles["p-field"]}>
            <label>Date</label>
            <p className={styles["event-input"]}>
              {formatDate(eventDetail?.start)}
            </p>
          </div>
        </>
      )}
    </div>
  );
};
EventDetailCalander.propTypes = {
  eventDetail: PropTypes.object,
  formatDate: PropTypes.func,
  handleCloseEventDetailCalander: PropTypes.func,
  backBtn: PropTypes.bool,
  handleViewMoreEvent: PropTypes.func,
};

export default EventDetailCalander;
